import { useTranslation } from '@aimsos/i18n';
import { DetailField } from '../shared/index.js';

const RISK_TONE = {
  Critical: 'text-rose-500',
  High: 'text-rose-500',
  Medium: 'text-amber-500',
  Low: 'text-emerald-500',
};

/**
 * Security context — prototype: risk classification + muted last-Break-Glass well.
 */
function SecurityContextBlock({ security }) {
  const { t } = useTranslation('work-queues-app');
  if (!security) return null;

  return (
    <div>
      <p className="text-xs font-semibold uppercase tracking-wide text-content-faint">
        {t('breakGlass.securityContext')}
      </p>

      {security.riskTier && (
        <dl className="mt-3">
          <DetailField
            label={t('breakGlass.riskTier')}
            value={
              <span
                className={['font-semibold', RISK_TONE[security.riskTier] ?? 'text-content'].join(' ')}
              >
                {security.riskTier}
              </span>
            }
          />
        </dl>
      )}

      {security.lastBreakGlass && (
        <div className="mt-3 rounded-md border border-edge bg-surface-muted px-3.5 py-3">
          <p className="text-sm leading-relaxed text-content-secondary">
            {t('breakGlass.lastBreakGlassForPartition', { detail: security.lastBreakGlass })}
          </p>
        </div>
      )}
    </div>
  );
}

export default SecurityContextBlock;
